import {
  Layout,
  Links,
  Main,
  MainMobile,
  MobileLayout,
  Nav,
  NavLink,
  NavMobile
} from './kycLayoutStyled';

import { RouteComponentProps, useHistory, useRouteMatch } from 'react-router';

import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import {
  KYC_AGREEMENT,
  KYC_BIRTH_DETAILS,
  KYC_CONGRATULATIONS,
  KYC_DOCUMENT_DETAILS,
  KYC_DOCUMENT_PHOTOS,
  KYC_SELFIE_TIME,
  KYC_START,
  PRIVACY_POLICY,
  TERMS_OF_USE
} from '../../routes/routes';
import { Button, ProgressBar } from '../../styles/GlobalComponents';
import { globalImages } from '../../styles/GlobalStyles';

const KycLayout = ({ children }: any) => {
  const { t } = useTranslation('kyc');
  const path = useHistory().location.pathname;
  const history = useHistory();
  const KYC_DOCUMENT_PHOTOS_MATCH = useRouteMatch(
    `${KYC_DOCUMENT_PHOTOS}/:id`
  )?.url;

  const { user, kycStatus } = useAppSelector((state) => state.auth.userInfo);

  const stateFor1 = () => {
    if (path === KYC_AGREEMENT) {
      return 2;
    }
  };

  const stateFor2 = () => {
    if (path === KYC_BIRTH_DETAILS) {
      return 2;
    }
  };

  const stateFor3 = () => {
    if (path === KYC_DOCUMENT_DETAILS) {
      return 2;
    }
  };

  const stateFor4 = () => {
    if (path === KYC_DOCUMENT_PHOTOS_MATCH) {
      return 2;
    }
  };

  const stateFor5 = () => {
    if (path === KYC_SELFIE_TIME) {
      return 2;
    }
  };

  const RouteObj = () => {
    switch (path) {
      case KYC_START:
        return {
          progress: '0%',
          title: `1. ${t('layout.agreement')}`,
          step: '0'
        };
      case KYC_AGREEMENT:
        return {
          progress: '20%',
          title: `1. ${t('layout.agreement')}`,
          step: '1'
        };
      case KYC_BIRTH_DETAILS:
        return {
          progress: '40%',
          title: `2. ${t('layout.personalDetails')}`,
          step: '2'
        };
      case KYC_DOCUMENT_DETAILS:
        return {
          progress: '60%',
          title: `3. ${t('layout.documentDetails')}`,
          step: '3'
        };
      case KYC_DOCUMENT_PHOTOS_MATCH:
        return {
          progress: '80%',
          title: `4. ${t('layout.documentPhotos')}`,
          step: '4'
        };

      case KYC_SELFIE_TIME:
        return {
          progress: '100%',
          title: `5. ${t('layout.selfieTime')}`,
          step: '5'
        };
      case KYC_CONGRATULATIONS:
        return {
          progress: '100%',
          title: `5. ${t('layout.selfieTime')}`,
          step: '5'
        };

      default:
        return null;
    }
  };

  return (
    <>
      <Layout>
        <Nav>
          <img src={globalImages.kycLayoutLogo} alt='logo' />
          <div>
            <NavLink state={stateFor1()}>
              <span />
              1. {t('layout.agreement')}
            </NavLink>
            {!user?.dateOfBirth ? (
              <NavLink state={stateFor2()}>
                <span />
                2. {t('layout.personalDetails')}
              </NavLink>
            ) : (
              <NavLink state={stateFor2()}>
                <span />
                2. {t('layout.personalDetails')}
              </NavLink>
            )}

            {!kycStatus?.documentType ? (
              <NavLink state={stateFor3()}>
                <span />
                3. {t('layout.documentDetails')}
              </NavLink>
            ) : (
              <NavLink state={stateFor3()}>
                <span />
                3. {t('layout.documentDetails')}
              </NavLink>
            )}

            {!kycStatus?.documentType ? (
              <NavLink state={stateFor4()}>
                <span />
                4. {t('layout.documentPhotos')}
              </NavLink>
            ) : (
              <NavLink state={stateFor4()}>
                <span />
                4. {t('layout.documentPhotos')}
              </NavLink>
            )}

            <NavLink state={stateFor5()}>
              <span />
              5. {t('layout.selfieTime')}
            </NavLink>
          </div>

          <div>
            <Links href={PRIVACY_POLICY} target='_blank'>
              {t('layout.privacyPolicy')}
            </Links>
            <Links href={TERMS_OF_USE} target='_blank'>
              {t('layout.termsAndConditions')}
            </Links>
          </div>

          <Button onClick={() => history.push('/backoffice/dashboard')}>
            {t('layout.back_to_dashboard')}
          </Button>
        </Nav>
        <Main>{children}</Main>
      </Layout>
      <MobileLayout style={{ paddingTop: RouteObj()?.step === '0' ? 100 : 0 }}>
        {path !== KYC_CONGRATULATIONS && (
          <NavMobile
            style={{
              display: RouteObj()?.step === '0' ? 'none' : ''
            }}>
            <h1>{RouteObj()?.title}</h1>
            <h2>
              Step <span>{RouteObj()?.step}</span> of 5
            </h2>
            <ProgressBar
              style={{ padding: 0 }}
              percentage={() => RouteObj()?.progress}>
              <div></div>
            </ProgressBar>
          </NavMobile>
        )}

        <MainMobile>{children}</MainMobile>
      </MobileLayout>
    </>
  );
};

export default KycLayout;
